import { buildPluExport, PluExportFormat } from '@iws/pos-devices'

import { ProductModel } from '@/http/models'
import { codeOf } from '@/services/printer'

/**
 * Downloads the PLU list for a label-printing scale in its model's format (POS.md §18.8): every product with a
 * `plu_code`, priced per its unit. Products made offline get their PLU when they sync, so they appear after that.
 */
export const downloadPluList = async (format: PluExportFormat, name: string) => {
  const res = await ProductModel.getList()
  if (!res.success || !res.data) throw new Error('Could not read the catalog')
  const rows = res.data.items.map((p) => ({ plu_code: p.plu_code ?? null, name: p.name, price: p.price, unit_price: p.price, barcode: codeOf(p) }))
  const { filename, text } = buildPluExport(rows, format)
  const count = rows.filter((r) => r.plu_code).length
  const url = URL.createObjectURL(new Blob([text], { type: 'text/plain' }))
  const a = Object.assign(document.createElement('a'), { href: url, download: `${name.replace(/[^\w-]+/g, '_')}-${filename}` })
  a.click()
  URL.revokeObjectURL(url)
  return count
}
